import { User } from "./user";

export class Team {
    teamId : number;
    name : string;
    description : string;
    users: User[];

    constructor() {
        this.teamId = 0;
        this.name = "";
        this.description = "";
        this.users = [];
    }
}